export default __webpack_public_path__ + "static/media/element_72.c3ad8aaa.webp";